var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"empty-ph fw-bold text-center text-secondary"},[_vm._v(" "+_vm._s(_vm.cropSelection.you_choose)+" ")]),_c('p',{staticClass:"empty-ph text-center"},[_vm._v(" "+_vm._s(_vm.selected.join(', '))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }